import type { LogRecord, ResponseLogMapperFactory } from '@wkda/logger-core';
import { LogLevel } from '@wkda/logger-core';

interface APICallHeaders {
  ['x-b3-traceid']: string;
  ['user-agent']: string;
}
interface APIRequest {
  url: string;
  method: string;
  headers: APICallHeaders;
}

export interface APIMiddlewareResponse {
  config: APIRequest;
  result: unknown;
  error: Error;
  statusCode: number;
  headers: APICallHeaders;
}

function getOriginalURL(rawURL: string): string {
  try {
    const url = new URL(rawURL);
    return url.pathname + url.search;
  } catch {
    return rawURL;
  }
}

function getDomain(rawURL: string): string | undefined {
  try {
    return new URL(rawURL).hostname;
  } catch {
    return;
  }
}

export const createAPIMiddlewareResponseLogMapper: ResponseLogMapperFactory<
  APIMiddlewareResponse
> = (config) => ({
  toDto(res, meta, message) {
    const logRecord: LogRecord = {
      logLevel:
        !res.statusCode || res.statusCode >= 500
          ? LogLevel.ERROR
          : LogLevel.INFO,
      logger: config.loggerName,
      timestamp: new Date(),
      duration: meta.duration,
      userAgent:
        typeof window !== 'undefined'
          ? window.navigator.userAgent
          : res.config?.headers['user-agent'],
      traceId: res.headers?.['x-b3-traceid'],
      request: {
        url: getOriginalURL(res.config?.url),
        method: res.config?.method,
        statusCode: res.statusCode,
        domain: getDomain(res.config?.url),
        referrer:
          typeof window !== 'undefined' ? window.location.href : undefined,
      },
      message,
    };

    return logRecord;
  },
});
